export const Pool = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M3 16.618a4.434 4.434 0 013.6 0 4.434 4.434 0 003.6 0 4.434 4.434 0 013.6 0 4.434 4.434 0 003.6 0 4.434 4.434 0 013.6 0M8 8h8M8 12h8M16 14V4.5A1.5 1.5 0 0117.5 3v0A1.5 1.5 0 0119 4.5M8 14V4.5A1.5 1.5 0 019.5 3v0A1.5 1.5 0 0111 4.5M3 20.618a4.434 4.434 0 013.6 0 4.434 4.434 0 003.6 0 4.434 4.434 0 013.6 0 4.434 4.434 0 003.6 0 4.434 4.434 0 013.6 0'
        ></path>
      </svg>
    </span>
  );
};
